import { MutableRefObject, useRef } from 'react';

export function usePersistentRef<T>(val: T): MutableRefObject<T> {
  const ref = useRef<T>(val);
  ref.current = val;
  return ref;
}
